import { ReactElement, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext, AuthContextType } from '../hooks/useAuth';

export const ProtectedRoute: React.FC<{ children: ReactElement }> = ({
  children,
}) => {
  const { auth, setAuthData } = useContext(AuthContext) as AuthContextType;

  const accessToken =
    auth.data?.accessToken || window.localStorage.getItem('accessToken');

  if (!accessToken) {
    // clear auth and redirect
    setAuthData(null);
    return <Navigate to="/" />;
  }

  return children;
};
